import { createContext } from 'react'

import { FoundationsContextType } from './FoundationsContext.types'

export const FoundationsContext = createContext<FoundationsContextType | undefined>(undefined)
